const menuHolder = document.querySelector(".header-nav");

const init = () => {
  modal();
  nav();

  if (document.querySelector(".slider")) {
    slider();
  }
};

const nav = () => {
  const menuOpener = document.querySelector(".js-nav-open");
  menuOpener.addEventListener("click", (event) => {
    event.preventDefault();
    menuHolder.classList.toggle("active");
  });
};

const slider = () => {
  tns({
    container: ".slider",
    controls: true,
    nav: true,
    navPosition: "bottom",
    items: 1,
  });
};

const modal = () => {
  const elModal = document.querySelector(".js-modal");
  const elModalOpenLinks = document.querySelectorAll(".js-modal-open");

  elModalOpenLinks.forEach((el) => {
    el.addEventListener("click", (evt) => {
      evt.preventDefault();
      const type = el.dataset.modal;
      const item = el.dataset.modalItem;
      const data = el.dataset.modalData;

      if (data) {
        populateModal(JSON.parse(data));
      } else {
        if (item && modalData?.hasOwnProperty(item)) {
          populateModal(modalData[item]);
        }
      }

      elModal.classList.add(`modal--${type}`);
      elModal.style.display = "block";
      elModal.style.top = `${window.scrollY}px`;
      window.kamScrollOffset = window.scrollY;
      menuHolder.classList.remove("active");
      return false;
    });
  });

  const elModalCloseLinks = document.querySelectorAll(".js-modal-close");
  elModalCloseLinks.forEach((el) => {
    el.addEventListener("click", () => {
      el.closest(".modal").className = "modal js-modal";
      el.closest(".modal").style.display = "none";

      if (window.kamScrollOffset) {
        window.scrollTo(0, window.kamScrollOffset);
      }

      return false;
    });
  });
};

const populateModal = ({ image, imageCredit, title, subtitle, content }) => {
  const modalTitle = document.querySelector(".js-modal-title");
  const modalSubtitle = document.querySelector(".js-modal-subtitle");
  const modalImage = document.querySelector(".js-modal-image");
  const modalImageCredit = document.querySelector(".js-modal-image-content");
  const modalContent = document.querySelector(".js-modal-content");

  modalTitle.innerHTML = title || null;
  modalSubtitle.innerHTML = subtitle || null;
  modalContent.innerHTML = content || null;

  if (image) {
    modalImageCredit.style.display = "block";
    modalImage.src = image || null;
    modalImageCredit.style.setProperty("--content", `"${imageCredit}"` || null);
  } else {
    modalImageCredit.style.display = "none";
  }
};

if (document.readyState !== "loading") {
  init();
} else {
  document.addEventListener("DOMContentLoaded", init);
}
